<template>
  <div class="flex flex-col items-center">
    <div
      class="slot mb-8 bg-primary-shade-1 rounded-md flex justify-center items-center"
    >
      <span class="text-lg font-semibold">
        {{ day }}
      </span>
    </div>
    <div
      v-if="!pastMealPlan"
      id="addNew"
      class="slot cursor-pointer shadow-md mb-4 rounded-md flex justify-center items-center"
      @click="addNew"
    >
      <span class="underline text-xs font-semibold text-gray-400">
        + Add New
      </span>
    </div>
    <draggable
      v-if="!pastMealPlan"
      class="list-group-meals"
      :list="newMeals"
      group="newMeals"
      draggable=".item"
    >
      <transition-group name="fade">
        <Meal
          class="item"
          v-for="(meal, i) in newMeals"
          :key="`${meal.title}-${i}`"
          :meal="meal"
          @removeMealList="removeMealFromList"
          @click="goToRecipe(meal)"
          style="transition: all 0.25s ease"
        />
      </transition-group>
    </draggable>
    <div v-else>
      <Meal
        v-for="(meal, i) in pastMeals"
        :key="`${meal.title}-${i}`"
        :meal="meal"
        :pastMeal="pastMealPlan"
        @removeMealList="removeMealFromList"
        @click="goToRecipe(meal)"
      />
    </div>
    <MealsSummary :meals-summary="mealsSummary" />
  </div>
</template>

<script>
import Meal from "@/pages/MealPlanner/components/Meal";
import MealsSummary from "@/pages/MealPlanner/components/MealsSummary";
import draggable from "vuedraggable";
import RecipeModal from "@/pages/MyRecipes/components/RecipeModal";
import MyRecipesModal from "@/pages/MealPlanner/components/MyRecipesModal";

export default {
  name: "MealDay",
  components: {
    Meal,
    MealsSummary,
    draggable
  },
  props: {
    pastMealPlan: {
      type: Boolean,
      default: false
    },
    day: {
      type: String,
      default: null,
      required: true
    },
    pastMeals: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    newMeals: {
      get() {
        return this.$store.getters[`get${this.day}Meals`];
      },
      set(value) {
        this.$store.commit(`update${this.day}List`, value);
      }
    },
    clientRequirements() {
      return {
        proteins: 300,
        fats: 150,
        carbohydrates: 600,
        calories: 2200
      };
    },
    mealsSummary() {
      let proteinsSum = 0;
      let fatsSum = 0;
      let carbohydratesSUm = 0;
      let caloriesSum = 0;

      const meals = this.pastMealPlan ? this.pastMeals : this.newMeals;

      for (let i = 0; i < meals.length; i++) {
        const { proteins, fats, carbohydrates } = meals[i];

        proteinsSum += proteins;
        fatsSum += fats;
        carbohydratesSUm += carbohydrates;
        caloriesSum += proteins * 4 + fats * 9 + carbohydrates * 4;
      }

      return {
        proteins: {
          current: proteinsSum,
          goal: this.clientRequirements.proteins
        },
        fats: {
          current: fatsSum,
          goal: this.clientRequirements.fats
        },
        carbohydrates: {
          current: carbohydratesSUm,
          goal: this.clientRequirements.carbohydrates
        },
        calories: {
          current: caloriesSum,
          goal: this.clientRequirements.calories
        }
      };
    }
  },
  data() {
    return {
      import_to_file: ""
    };
  },
  methods: {
    removeMealFromList(mealId) {
      this.newMeals = this.newMeals.filter(({ id }) => mealId !== id);
    },
    addNew() {
      this.$modal.show(
        MyRecipesModal,
        {
          day: this.day
        },
        {
          name: "MyRecipesModal",
          classes:
            "MyRecipesModal rounded-xl overscroll-contain overflow-hidden",
          height: "auto",
          maxWidth: 600,
          scrollable: true,
          adaptive: true
        },
        {
          "before-close": ({ params }) => {
            if (!params?.recipe) {
              return;
            }

            this.$emit("addNew", {
              day: this.day,
              recipe: params.recipe
            });
          }
        }
      );
    },
    goToRecipe(recipe) {
      this.$modal.show(
        RecipeModal,
        {
          recipe
        },
        {
          name: "RecipeModal",
          classes: "RecipeModal rounded-xl rounded-r-none overscroll-contain",
          transition: "vm-transition--side-card",
          height: "100%",
          maxWidth: 600,
          shiftX: 1.0,
          scrollable: true,
          adaptive: true
        }
      );
    }
  },
  created() {}
};
</script>

<style scoped>
.slot {
  width: 9.375rem;
  height: 3.75rem;
}

#addNew {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='5' ry='5' stroke='rgb(156, 163, 175)' stroke-width='2' stroke-dasharray='4' stroke-dashoffset='1' stroke-linecap='square'/%3e%3c/svg%3e");
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-leave-active {
  position: absolute;
}
</style>
